import React, { useCallback, Dispatch, SetStateAction } from 'react'
import { Button } from 'reactstrap'
import _ from 'lodash'
import { CheckoutAdditionalField } from '../types'
import * as S from '../../pages/style'
import Tabs from '../../components/Tabs'
import CanNotUpdate from '../../components/CanNotUpdate'
import CheckoutAdditionalFieldRow from './CheckoutAdditionalFieldRow'
import { TAB_MODE } from 'containers/ReceptionCustom/constants'
import { MAX_FIELDS_COUNT } from '../constants'

type Props = {
  fields: CheckoutAdditionalField[]
  originalFields: CheckoutAdditionalField[]
  onUpdateFields: Dispatch<SetStateAction<CheckoutAdditionalField[]>>
  onAddField: () => void
  onSubmit: () => void
  onClickEdit: (index: number) => void
  canUpdate: boolean
}

export const CheckoutAdditionalFieldsForm: React.FC<Props> = ({
  fields,
  originalFields,
  onUpdateFields,
  onAddField,
  onSubmit,
  onClickEdit,
  canUpdate,
}) => {
  const handleUpdateField = useCallback(
    (index: number, updatedField: CheckoutAdditionalField) => {
      onUpdateFields((prevFields: CheckoutAdditionalField[]) => {
        const newFields = [...prevFields]
        newFields[index] = updatedField
        return newFields
      })
    },
    [onUpdateFields]
  )

  const handleRemoveField = useCallback(
    (index: number) => {
      onUpdateFields((prevFields: CheckoutAdditionalField[]) =>
        prevFields.filter((_, i) => i !== index)
      )
    },
    [onUpdateFields]
  )

  const handleEditField = useCallback(
    (index: number) => {
      onClickEdit(index)
    },
    [onClickEdit]
  )

  return (
    <S.TimeSettingWrapper>
      <S.SettingContent>
        <div className="font-weight-bold mb-3">受付カスタマイズ</div>
        {!canUpdate && <CanNotUpdate />}
        <div className="border px-3 mx-auto mb-3 bg-white">
          <Tabs currentTabId={TAB_MODE.CHECKOUT_ADDITIONAL_FIELDS} />
          <div className="mb-3 text-center">
            退場時の入力項目として表示/非表示を選択し、表示の場合は必須/任意をお選びください
          </div>
          <div className="m-3">
            <div className="mb-3" style={{ overflowY: 'auto' }}>
              <table className="w-100">
                <thead
                  className="border-bottom"
                  style={{ backgroundColor: '#f0f0f0', zIndex: 2 }}
                >
                  <tr>
                    <th className="pl-3 py-3">項目名</th>
                    <th className="text-center py-3" />
                    <th className="text-center py-3" style={{ width: 130 }} />
                    <th className="text-center py-3" style={{ width: 130 }}>必須項目</th>
                    <th className="text-center py-3 pr-3" style={{ width: 130 }}>表示／非表示</th>
                    <th className="text-center py-3 pr-3" style={{ width: 50 }}></th>
                  </tr>
                </thead>
                <tbody className="border-0">
                  {fields.map((item, index) => (
                    <CheckoutAdditionalFieldRow
                      key={index}
                      field={item}
                      index={index}
                      onUpdateField={handleUpdateField}
                      onClickEdit={handleEditField}
                      onClickRemove={handleRemoveField}
                      canUpdate={canUpdate}
                    />
                  ))}
                </tbody>
              </table>
              <div className="text-right m-2">
                {fields.length >= MAX_FIELDS_COUNT && (
                  <span className="ml-2 text-muted" style={{ fontSize: 12 }}>
                    （最大{MAX_FIELDS_COUNT}件）
                  </span>
                )}
                <Button
                  color="primary"
                  className="rounded-pill"
                  onClick={onAddField}
                  disabled={!canUpdate || fields.length >= MAX_FIELDS_COUNT}
                >
                  項目を追加
                </Button>
              </div>
            </div>
          </div>
        </div>

        {canUpdate && (
          <div className="text-right m-2">
            <Button
              color="primary"
              className="rounded-pill px-4"
              disabled={_.isEqual(originalFields, fields)}
              onClick={onSubmit}
            >
              登録
            </Button>
          </div>
        )}
      </S.SettingContent>
    </S.TimeSettingWrapper>
  )
}

export default CheckoutAdditionalFieldsForm
